import React from 'react'
import Chart from 'react-apexcharts'
import ChartCard from './ChartCard'
import { formatCurrency } from '../mockData'

export default function AccountsPayableChart({ data }) {
    const barColors = data.values.map((v) =>
        v >= data.threshold ? '#EF4444' : '#3B82F6'
    )

    const options = {
        chart: {
            type: 'bar',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        plotOptions: {
            bar: {
                columnWidth: '50%',
                borderRadius: 6,
                distributed: true,
            },
        },
        xaxis: {
            categories: data.categories,
            labels: { style: { colors: '#64748B', fontSize: '11px' } },
        },
        yaxis: {
            labels: {
                style: { colors: '#64748B', fontSize: '12px' },
                formatter: (val) => `R$ ${(val / 1000).toFixed(0)}k`,
            },
        },
        colors: barColors,
        legend: { show: false },
        tooltip: {
            theme: 'light',
            y: { formatter: (val) => formatCurrency(val) },
        },
        grid: {
            borderColor: '#E2E8F0',
            strokeDashArray: 4,
        },
        dataLabels: {
            enabled: true,
            formatter: (val) => formatCurrency(val),
            style: { fontSize: '12px', fontWeight: 600, colors: ['#fff'] },
        },
        annotations: {
            yaxis: [{
                y: data.threshold,
                borderColor: '#F59E0B',
                strokeDashArray: 4,
                label: {
                    text: `Alerta: ${formatCurrency(data.threshold)}`,
                    borderColor: '#F59E0B',
                    style: { color: '#fff', background: '#F59E0B', fontSize: '11px' },
                },
            }],
        },
    }

    const series = [{
        name: 'A Pagar',
        data: data.values,
    }]

    return (
        <ChartCard title="Contas a Pagar" subtitle="Próximos 30 dias por semana">
            <Chart options={options} series={series} type="bar" height={300} />
        </ChartCard>
    )
}
